import { buildAroValidationContext } from './aroValidationContext'
import { buildMaxCharRule } from './validationRuleBuilders'

/**
 * Builds the Uncashed Checks (IRA Eligible) validation context by extending the shared
 * ARO base context with UCH-specific field rules.
 *
 * Shared fields (recordkeeper, tpa, planSponsor, planName, planEin, etc.) are inherited
 * from buildAroValidationContext unchanged. UCH-specific fields (wasTaxWithheld) are
 * added here. dateOfOriginalDistribution validation is procedural and lives in the
 * pure-validator functions in ParticipantsDataFormatting.
 *
 * @param {string} userAudience - e.g. 'Recordkeeper', 'TPA'
 * @returns {object} Validation context for Uncashed Checks listeners and pure validators
 */
export function buildUncashedChecksValidationContext(userAudience) {
  const base = buildAroValidationContext(userAudience)

  return {
    // ── All shared ARO fields (recordkeeper, tpa, planSponsor, planName, planEin,
    //    planNumber, planIdNumber, firstName, middleName, lastName, addressLine1,
    //    addressLine2, city, ssn, emailAddress, IRA amounts, audience flags,
    //    and pure-validator formats: ssnFormat, dobFormat, zipCodeFormat) ────────
    ...base,

    // ── Uncashed Checks-specific field rules ───────────────────────────────────
    countryCode: {
      maxChar: buildMaxCharRule(2),
    },
    wasTaxWithheld: {
      validValues: {
        re: /^[YN]$/,
        error: 'Must be Y or N',
      },
    },
  }
}
